const convertNumberToPrice = (number: number) => {
  const formattedNum = Math.floor(number).toLocaleString();
  return formattedNum;
};

export default convertNumberToPrice;
